import qs from "qs";
import { useCallback, useState } from "react";
import { PackagesSearchCriteria } from "../types/packages/PackagesSearchCriteria";
import { CommunicationType } from "../enums/CommunicationType";
import { useAppAttributes } from "./useAppAttributes";

export function usePackagesSearchCriteria(isInitialTab: boolean) {
  const appAttributes = useAppAttributes();
  // Params
  const getPackagesSearchCriteriaParams = useCallback((): PackagesSearchCriteria => {
    const locationParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    const searchCriteria = new PackagesSearchCriteria(locationParams as { [key: string]: string });
    return searchCriteria;
  }, []);

  // State
  const [searchCriteria, setSearchCriteria] = useState(
    isInitialTab && appAttributes.communicationType === CommunicationType.Standalone
      ? getPackagesSearchCriteriaParams()
      : undefined
  );
  const [previousSearchCriteria, setPreviousSearchCriteria] = useState<PackagesSearchCriteria>();

  const changeSearchCriteria = useCallback((searchCriteria: PackagesSearchCriteria) => {
    setSearchCriteria((currentSearchCriteria) => {
      setPreviousSearchCriteria(currentSearchCriteria);
      return searchCriteria;
    });
  }, []);

  return { previousSearchCriteria, searchCriteria, setSearchCriteria: changeSearchCriteria };
}
